/**
 * 提供全局常量
 * (c) 2017 进门web团队
 * **/

// 特殊说明：
// 临时添加变量：hide_special_live 表示是否要显示专场相关直播
export const hide_special_live = false;

export const isBuild =
	/(https|http):\/\/(premobile\.comein\.cn|mobile\.comein\.cn|tmobile\.comein\.cn|resource\.comein\.cn|ios-route-0\.comein\.cn|47\.110\.154\.223)/i.test(
		location.href.toLowerCase()
	);
export const isDev = /https:\/\/(devmobile\.comein\.cn|devserver\.comein\.cn)/i.test(location.href.toLowerCase());
export const isTest = /https:\/\/(testmobile\.comein\.cn|testserver\.comein\.cn)/i.test(location.href.toLowerCase());
export const isLocalhost = !isBuild && !isDev && !isTest;

export const isApp = /ComeinFinance/i.test(navigator.userAgent.toLowerCase());

export const isWx = /micromessenger/.test(window.navigator.userAgent.toLowerCase());

export const isWxWork = /wxwork/.test(window.navigator.userAgent.toLowerCase());

export const isOpenHarmony = /OpenHarmony/i.test(navigator.userAgent.toLowerCase());

export const isIos = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent.toLowerCase());

export const isAndroid = /Android/i.test(navigator.userAgent.toLowerCase());

/* ios 支持 __wxjs_environment ， 安卓支持 UA */
export const isWxMiniProgram = /miniprogram/.test((window.__wxjs_environment || navigator.userAgent).toLowerCase());

export const isMiniDevtool = /wechatdevtools/.test(navigator.userAgent.toLowerCase());

/** 项目版本号 **/
export const VERSION = '2.2.1';
export const IR_VERSION = '1.2.0';

/** 接口版本号 **/
export const REQUEST_VERSION = '4.2.0800';
/** 加密的盐 */
export const REQUEST_SALT = isBuild ? '039ed7d839d8915bf01e4f49825fcc6b' : '4bdc587e345b45a3be4a57dc95637822';

/** PDF密码 **/
export const PDFCODE = '!qaz@wsx#edc';

export const TOKEN_CODE = 'A7#9K2$1jP!LzQ8W';

// strophe
// domain
export const STROPHEDOMAIN = '@ay131026204339z';
// resource
export const STROPHERES = '/mobile';

/** 存储用户信息key **/
export const OPENID = 'openid';
export const USERINFOKEY = 'userinfo';
export const THIRDPARTY = 'third_party';

export const ROADSHOW_SIGN = 'roadshow_sign';

/** 阿里支付商品链接 **/
export const ALIPAYURL = 'https://mapi.alipay.com/gateway.do?';

/** app下载地址 **/
export const APPSTORE = 'https://a.app.qq.com/o/simple.jsp?pkgname=cn.comein';

/** 苹果app下载地址 **/
export const iOSAPPSTORE = 'https://apps.apple.com/cn/app/id835896061';

/** 安卓app下载地址 **/
export const androidAPPSTORE = 'https://resource.comein.cn/comein-files/normal/comein.apk';

/** 进门logo地址 **/
export const LOGO = 'https://resource.comein.cn/comein-files/img/default/logo@2x.png';

/** 中信证券logo地址 **/
export const ZXLOGO = 'https://resource.comein.cn/comein-files/img/default/zhongxinlogo.png';

/** 中金公司logo地址 */
export const ZJLOGO = 'https://image.comein.cn/comein-files/img/default/zhongjinlogo.png';

/** 默认头像 **/
export const DEFAULTAVATAR = 'https://image.comein.cn/comein-files/img/default/avatar.jpg';

/** 默认图 **/
export const DEFAULTIMG_1x1 = 'https://image.comein.cn/comein-files//img/default/contentlogo.png';

export const LOGO_PDF = 'https://resource.comein.cn/comein-files/img/summary/pdf.png';

export const LOGO_WORD = 'https://resource.comein.cn/comein-files/img/summary/word.png';

//分享榜logo
export const INVITERANKSHARELOGO = 'https://resource.comein.cn/comein-files/img/default/invite_rank_share_logo.png';

export const EMPTYBILLIMG = 'https://resource.comein.cn/comein-files/img/default/web/empty_bill@3x.png';
export const EMPTYFILEIMG = 'https://resource.comein.cn/comein-files/img/default/web/empty_file@3x.png';
export const EMPTYPEOPLEIMG = 'https://resource.comein.cn/comein-files/img/default/web/empty_people@3x.png';
export const EMPTYRECORDIMG = 'https://resource.comein.cn/comein-files/img/default/web/empty_record@3x.png';
export const EMPTYROADSHOWIMG = 'https://resource.comein.cn/comein-files/img/default/web/empty_roadshow@3x.png';
export const NOCONTENTIMG = 'https://resource.comein.cn/comein-files/img/default/web/no_content@3x.png';
export const NONETWORKIMG = 'https://resource.comein.cn/comein-files/img/default/web/no_network@3x.png';
// 移动分享端头像
export const LOGO_SHARE = 'https://image.comein.cn/web/irm/web/default/enterprise-share.png';

/** 机构通分享img **/
export const VIPINSTITUTIONSHARE = 'https://testimage.comein.cn/comein-files/img/default/web/vip_institution_share.png';

/** 会员详情页分享转发 */
export const MEMBER_SHARE_WX_IMG = 'https://image.comein.cn/comein-files/img/default/member-share.png';
export const MEMBER_SHARE_WXMINIPROGRAM_IMG =
	'https://image.comein.cn/comein-files/img/default/member-share-wxMiniProgram.jpg';

/** 第三方个股详情页面 **/
// export const HENGSHENGSTOCKPAGE = 'https://6uyj71nht.lightyy.com/index.html#quote?code=';

/** 嵌入恒生页面中请求进门接口携带的token参数 **/
export const APPACCESSTOKEN = 'MDljNWUxZTAtMTk4OS00MDQ4LTkwOTYtNTc4YWU3YTkwZjJj';

/** 进门小程序APPID **/
export const WXMINIPROGRAMID = 'gh_5a3b0203aaa7';

/**APP 浏览器配置参数（采用位运算） */
/**显示隐藏控制 */
/* 隐藏加载的动画 */
export const APP_BROWSER_HIDDEN_VIEW_LOADING_ANIMATION = 1 << 0;
/* 隐藏加载的进度条 */
export const APP_BROWSER_HIDDEN_VIEW_LOADING_PROGRESS = 1 << 1;
/* 隐藏错误提示 */
export const APP_BROWSER_HIDDEN_VIEW_FAILED_PROMPT = 1 << 2;
/* 隐藏导航栏背景 */
export const APP_BROWSER_HIDDEN_NAVIGATION_BAR_BACKGROUND = 1 << 3;
/* 隐藏返回按钮 */
export const APP_BROWSER_HIDDEN_NAVIGATION_BAR_BACK = 1 << 4;
/* 隐藏标题 */
export const APP_BROWSER_HIDDEN_NAVIGATION_BAR_TITLE = 1 << 5;
/* 隐藏分享按钮 */
export const APP_BROWSER_HIDDEN_NAVIGATION_BAR_SHARE = 1 << 6;

/* 样式控制 */
/* 状态栏 */
// dark:黑色
export const APP_BROWSER_STYLE_STATUS_BAR_DARK = 0 << 8;
// light:白色
export const APP_BROWSER_STYLE_STATUS_BAR_LIGHT = 1 << 8;
/* 页面背景 */
export const APP_BROWSER_STYLE_VIEW_BACKGROUND_LIGHT = 0 << 9;
export const APP_BROWSER_STYLE_VIEW_BACKGROUND_DARK = 1 << 9;
/* 页面加载的动画 */
export const APP_BROWSER_STYLE_VIEW_LOADING_ANIMATION_LIGHT = 0 << 10;
export const APP_BROWSER_STYLE_VIEW_LOADING_ANIMATION_DARK = 1 << 10;
/* 页面加载进度 */
export const APP_BROWSER_STYLE_VIEW_LOADING_PROGRESS_LIGHT = 0 << 11;
export const APP_BROWSER_STYLE_VIEW_LOADING_PROGRESS_DARK = 1 << 11;
/* 页面加载失败提示 */
export const APP_BROWSER_STYLE_VIEW_FAILED_PROMPT_LIGHT = 0 << 12;
export const APP_BROWSER_STYLE_VIEW_FAILED_PROMPT_DARK = 1 << 12;
/* 导航背景 */
export const APP_BROWSER_STYLE_NAVIGATION_BAR_BACKGROUND_LIGHT = 0 << 13;
export const APP_BROWSER_STYLE_NAVIGATION_BAR_BACKGROUND_DARK = 1 << 13;
/* 返回按钮 */
// 0:RGB(0,0,0);1:RGB(255,255,255)
export const APP_BROWSER_STYLE_NAVIGATION_BAR_BACK_DARK = 0 << 14;
export const APP_BROWSER_STYLE_NAVIGATION_BAR_BACK_LIGHT = 1 << 14;
/* 标题 */
export const APP_BROWSER_STYLE_NAVIGATION_BAR_TITLE_DARK = 0 << 15;
export const APP_BROWSER_STYLE_NAVIGATION_BAR_TITLE_LIGHT = 1 << 15;
/* 分享 */
export const APP_BROWSER_STYLE_NAVIGATION_BAR_SHARE_DARK = 0 << 16;
export const APP_BROWSER_STYLE_NAVIGATION_BAR_SHARE_LIGHT = 1 << 16;
/* 滚动条 */
export const APP_BROWSER_STYLE_DISABLE_SCROLL = 1 << 24;

/** 环境变量正式(build)/测试(test)/开发(dev) **/
let // 首页各个板块id
	banner_id_vip,
	banner_id_adv,
	banner_id_topic,
	banner_id_recent,
	banner_id_article,
	banner_id_hot_live,
	banner_id_hot_roadshow,
	banner_id_recommend,
	banner_id_character,
	banner_id_institute,
	banner_id_choice,
	banner_id_record_book,
	banner_id_course,
	banner_id_live_preview,
	banner_id_stock_market,
	banner_id_recommend_live,
	banner_id_column,
	//3.5.0首页模块
	banner_styletype_adv,
	banner_styletype_roadshow_preview,
	banner_styletype_recent,
	banner_styletype_hot_roadshow,
	banner_styletype_column,
	banner_styletype_topic,
	banner_styletype_course,
	//3.6.0新增上市公司模块
	banner_styletype_public_company,
	banner_id_public_company,
	//3.6.4首页新增调研活动、约调研模块
	banner_styletype_enrollment,
	banner_styletype_appoint,
	//3.6.15行业专家
	banner_id_financial,
	//3.6.17机构通专区
	banner_styletype_vip_institution,
	// 3.8.4 会员专区
	banner_styletype_member,
	// webInApp整合页地址
	webinapp_url,
	// pc 路演地址
	pc_roadshow_url,
	// 官网 路演地址
	portal_roadshow_url,
	// PC 券商定制页
	pc_institute_home,
	// 专题页面
	topic_url,
	// 外部路演厅地址
	event_url,
	// 股票地址
	stock_url,
	// 上市公司调研
	invsgt_url,
	// 资讯(文章)地址
	article_url,
	// 项目主页
	mobile,
	// 项目主页
	mobile_home,
	// 外部回放地址
	playback_url,
	// 风险测评
	evaluate_url,
	// 分析师页面
	character_url,
	// 研究所
	institute_url,
	// 实名认证
	real_name_url,
	// K线图
	k_chart_event,
	// vip购买成功后回调地址
	vip_pay_return_url,
	// 股票推荐K线图
	stock_rec_chart_url,
	// irm活动报名地址
	enrollment_url,
	// 图片根目录
	img_root,
	// websocket地址
	socket_url,
	socket_ip,
	// 行情iframe，沪深恒生嵌入页面
	hengsheng_market_src,
	//	第三方股票地址，个股详情页
	hengsheng_stock_src,
	// F10, 融资融券post地址
	hengsheng_rzrq_src,
	// agora播放器appId
	agora_app_id,
	// pdf阅读地址（有水印功能）
	pdf_viewer_url,
	// 互金合作项目地址
	third_party_url,
	// 浙商小程序请求域名
	srs_url,
	// pc自助会议
	pc_meeting,
	// pc自助会议登录授权
	pc_meeting_authorize,
	// 自组会议详情页
	h_five_meeting_detail,
	// iosAPP跳转域名
	ios_route,
	mobile_url,
	// 白噪音请求域名
	wmserverUrl,
	// (微信)人脸识别实名核身鉴权(腾讯云)
	face_url,
	// PC官网域名
	pc_comein_url,
	// PC专题列表
	pc_subject_url;

if (isTest) {
	banner_id_adv = '17';
	banner_id_vip = '27';
	banner_id_topic = '1';
	banner_id_recent = '6';
	banner_id_article = '20';
	banner_id_institute = '7';
	banner_id_hot_live = '13';
	banner_id_hot_roadshow = '210';
	banner_id_recommend = '10';
	banner_id_character = '12';
	banner_id_choice = '19';
	banner_id_live_preview = '5';
	banner_id_record_book = '15';
	banner_id_course = '41';
	banner_id_stock_market = '18';
	banner_id_recommend_live = '9';
	banner_id_column = '219';
	banner_id_public_company = '283';
	banner_id_financial = '37';
	banner_styletype_adv = '91';
	banner_styletype_roadshow_preview = '13';
	banner_styletype_recent = '42';
	banner_styletype_hot_roadshow = '43';
	banner_styletype_public_company = '20';
	banner_styletype_column = '121';
	banner_styletype_topic = '111';
	banner_styletype_course = '1701';
	banner_styletype_enrollment = '1303';
	banner_styletype_appoint = '1304';
	banner_styletype_vip_institution = '1305';
	banner_styletype_member = '1306';

	webinapp_url = 'https://testmobile.comein.cn/mobile/';
	pc_roadshow_url = 'https://testnet.comein.cn/roadshow/home/';
	portal_roadshow_url = 'https://testportal.comein.cn/roadshow/home/';
	pc_institute_home = 'https://testnet.comein.cn/institute/';
	vip_pay_return_url = 'https://s.comein.cn/xmt';
	mobile = 'https://testmobile.comein.cn';
	mobile_home = 'https://testmobile.comein.cn/mobile/home';
	stock_url = 'https://testmobile.comein.cn/mobile/stock?id=';
	topic_url = 'https://testmobile.comein.cn/mobile/topic?id=';
	article_url = 'https://testmobile.comein.cn/mobile/article?id=';
	character_url = 'https://testmobile.comein.cn/mobile/character?id=';
	institute_url = 'https://testmobile.comein.cn/mobile/institute?id=';
	real_name_url = 'https://testmobile.comein.cn/mobile/biz/realnameaut';
	event_url = 'https://testmobile.comein.cn/mobile/live/index.html?eid=';
	invsgt_url = 'https://testmobile.comein.cn/mobile/biz/Invsgt/detail?actId=';
	playback_url = 'https://testmobile.comein.cn/mobile/playback/index.html?eid='; // 需要eid，第二个参数为rid(格式为：?eid=4356&rid=2073)
	evaluate_url = 'https://testmobile.comein.cn/mobile/biz/riskevaluation/result';
	k_chart_event =
		'https://testmobile.comein.cn/mobile/stockchart/index.html?timestamp=' + new Date().getTime() + '&stockid=';
	stock_rec_chart_url = 'https://testmobile.comein.cn/mobile/stockrec/stockrecchart.html?stockrecid=';
	enrollment_url = 'https://testmobile.comein.cn/mobile/enrollment/detail?id=';
	img_root = 'https://testimage.comein.cn/comein-files/';
	socket_url = 'wss://im-test.comein.cn:7443/ws/';
	socket_ip = 'testserver.comein.cn';

	// hengsheng_market_src = "https://xete2hrsc.lightyy.com/index.html";

	// 测试地址
	hengsheng_market_src = 'https://a8eytkc5q.lightyy.com/index.html';
	hengsheng_stock_src = 'https://6uyj71nht.lightyy.com/index.html';
	// hengsheng_rzrq_src = "https://tgv4me96l.lightyy.com";

	// 生产地址
	// hengsheng_market_src = "https://wmdnlc5p1.lightyy.com/index.html";
	// hengsheng_stock_src = "https://prhmvxckl.lightyy.com/index.html";
	hengsheng_rzrq_src = 'https://lrr18mo0k.lightyy.com/';

	agora_app_id = '173dbf69a0d94c968fbdc163f5badac2';

	pdf_viewer_url = 'https://testmobile.comein.cn/pdfviewer/web/viewer.html?file=';

	third_party_url = 'https://htmobile.comein.cn';

	srs_url = 'https://stocke-srs-test.comein.cn';
	pc_meeting = 'https://testportal.comein.cn/roadshow/meeting?id=';

	pc_meeting_authorize = 'https://testportal.comein.cn/roadshow/meeting-hint?redirect_uri=';
	h_five_meeting_detail = 'https://testmobile.comein.cn/mobile/meeting/detail?id=';
	ios_route = 'https://test-ios-route-0.comein.cn';
	mobile_url = 'https://testmobile.comein.cn';

	pc_comein_url = 'https://testportal.comein.cn';

	pc_subject_url = 'https://testportal.comein.cn/roadshow/subject-detail?id=';

	face_url = 'https://faceid.tencentcloudapi.com';

	wmserverUrl = 'https://test-wmserver.comein.cn';
} else if (isDev) {
	banner_id_adv = '17';
	banner_id_vip = '27';
	banner_id_topic = '1';
	banner_id_recent = '6';
	banner_id_article = '20';
	banner_id_hot_live = '13';
	banner_id_hot_roadshow = '210';
	banner_id_institute = '7';
	banner_id_character = '12';
	banner_id_recommend = '10';
	banner_id_choice = '19';
	banner_id_record_book = '15';
	banner_id_course = '41';
	banner_id_live_preview = '5';
	banner_id_stock_market = '18';
	banner_id_recommend_live = '9';
	banner_id_column = '219';
	banner_id_public_company = '283';
	banner_id_financial = '37';
	banner_styletype_adv = '91';
	banner_styletype_roadshow_preview = '13';
	banner_styletype_recent = '42';
	banner_styletype_hot_roadshow = '43';
	banner_styletype_public_company = '20';
	banner_styletype_column = '121';
	banner_styletype_topic = '111';
	banner_styletype_course = '1701';
	banner_styletype_enrollment = '1303';
	banner_styletype_appoint = '1304';
	banner_styletype_vip_institution = '1305';
	banner_styletype_member = '1306';

	webinapp_url = 'https://testmobile.comein.cn/mobile/';
	pc_roadshow_url = 'https://testnet.comein.cn/roadshow/home/';
	portal_roadshow_url = 'https://testportal.comein.cn/roadshow/home/';
	pc_institute_home = 'https://testnet.comein.cn/institute/';
	vip_pay_return_url = 'https://s.comein.cn/vYn';
	mobile = 'https://devmobile.comein.cn';
	mobile_home = 'https://devmobile.comein.cn/mobile/home';
	topic_url = 'https://devmobile.comein.cn/mobile/topic?id=';
	stock_url = 'https://devmobile.comein.cn/mobile/stock?id=';
	article_url = 'https://devmobile.comein.cn/mobile/article?id=';
	character_url = 'https://devmobile.comein.cn/mobile/character?id=';
	institute_url = 'https://devmobile.comein.cn/mobile/institute?id=';
	real_name_url = 'https://devmobile.comein.cn/mobile/biz/realnameaut';
	event_url = 'https://devmobile.comein.cn/mobile/live/index.html?eid=';
	invsgt_url = 'https://devmobile.comein.cn/mobile/biz/Invsgt/detail?actId=';
	playback_url = 'https://devmobile.comein.cn/mobile/playback/index.html?eid='; // 需要eid，第二个参数为rid(格式为：?eid=4356&rid=2073)
	evaluate_url = 'https://devmobile.comein.cn/mobile/biz/riskevaluation/result';
	k_chart_event =
		'https://devmobile.comein.cn/mobile/stockchart/index.html?timestamp=' + new Date().getTime() + '&stockid=';
	stock_rec_chart_url = 'https://devmobile.comein.cn/mobile/stockrec/stockrecchart.html?stockrecid=';
	enrollment_url = 'https://devmobile.comein.cn/mobile/enrollment/detail?id=';
	img_root = 'https://testimage.comein.cn/comein-files/';
	socket_url = 'wss://im-test.comein.cn:7443/ws/';
	socket_ip = 'testserver.comein.cn';
	// hengsheng_market_src = "https://xete2hrsc.lightyy.com/index.html";
	// hengsheng_market_src = "https://a8eytkc5q.lightyy.com/index.html";
	// hengsheng_stock_src = "https://6uyj71nht.lightyy.com/index.html";
	// hengsheng_rzrq_src = "https://tgv4me96l.lightyy.com";

	// 生产地址
	hengsheng_market_src = 'https://wmdnlc5p1.lightyy.com/index.html';
	hengsheng_stock_src = 'https://prhmvxckl.lightyy.com/index.html';
	hengsheng_rzrq_src = 'https://lrr18mo0k.lightyy.com/';

	agora_app_id = '173dbf69a0d94c968fbdc163f5badac2';

	pdf_viewer_url = 'https://testmobile.comein.cn/pdfviewer/web/viewer.html?file=';

	third_party_url = 'https://htmobile.comein.cn';

	srs_url = 'https://stocke-srs-test.comein.cn';
	pc_meeting = 'https://testportal.comein.cn/roadshow/meeting?id=';
	pc_meeting_authorize = 'https://testportal.comein.cn/roadshow/meeting-hint?redirect_uri=';
	h_five_meeting_detail = 'https://testmobile.comein.cn/mobile/meeting/detail?id=';
	ios_route = 'https://test-ios-route-0.comein.cn';
	mobile_url = 'https://testmobile.comein.cn';

	pc_comein_url = 'https://testportal.comein.cn';

	pc_subject_url = 'https://testportal.comein.cn/roadshow/subject-detail?id=';

	face_url = 'https://faceid.tencentcloudapi.com';

	wmserverUrl = 'https://test-wmserver.comein.cn';
} else if (isBuild) {
	banner_id_adv = '15';
	banner_id_vip = '22';
	banner_id_topic = '1';
	banner_id_recent = '6';
	banner_id_article = '18';
	banner_id_institute = '7';
	banner_id_hot_live = '12';
	banner_id_hot_roadshow = '60';
	banner_id_recommend = '10';
	banner_id_character = '18';
	banner_id_choice = '17';
	banner_id_record_book = '21';
	banner_id_course = '36';
	banner_id_live_preview = '5';
	banner_id_stock_market = '16';
	banner_id_recommend_live = '9';
	banner_id_column = '58';
	banner_id_public_company = '91';
	banner_id_financial = '32';
	banner_styletype_adv = '91';
	banner_styletype_roadshow_preview = '13';
	banner_styletype_recent = '42';
	banner_styletype_hot_roadshow = '43';
	banner_styletype_public_company = '20';
	banner_styletype_column = '121';
	banner_styletype_topic = '111';
	banner_styletype_course = '1701';
	banner_styletype_enrollment = '1303';
	banner_styletype_appoint = '1304';
	banner_styletype_vip_institution = '1305';
	banner_styletype_member = '1306';

	webinapp_url = 'https://mobile.comein.cn/mobile/';
	pc_roadshow_url = 'https://net.comein.cn/roadshow/home/';
	portal_roadshow_url = 'https://www.comein.cn/roadshow/home/';
	pc_institute_home = 'https://net.comein.cn/institute/';
	vip_pay_return_url = 'https://s.comein.cn/ihN';
	mobile = 'https://mobile.comein.cn';
	mobile_home = 'https://mobile.comein.cn/mobile/home';
	topic_url = 'https://mobile.comein.cn/mobile/topic?id=';
	stock_url = 'https://mobile.comein.cn/mobile/stock?id=';
	article_url = 'https://mobile.comein.cn/mobile/article?id=';
	character_url = 'https://mobile.comein.cn/mobile/character?id=';
	institute_url = 'https://mobile.comein.cn/mobile/institute?id=';
	real_name_url = 'https://mobile.comein.cn/mobile/biz/realnameaut';
	event_url = 'https://mobile.comein.cn/mobile/live/index.html?eid=';
	invsgt_url = 'https://mobile.comein.cn/mobile/biz/Invsgt/detail?actId=';
	playback_url = 'https://mobile.comein.cn/mobile/playback/index.html?eid='; // 需要eid，第二个参数为rid(格式为：?eid=4356&rid=2073)
	evaluate_url = 'https://mobile.comein.cn/mobile/biz/riskevaluation/result';
	k_chart_event =
		'https://mobile.comein.cn/mobile/stockchart/index.html?timestamp=' + new Date().getTime() + '&stockid=';
	stock_rec_chart_url = 'https://mobile.comein.cn/mobile/stockrec/stockrecchart.html?stockrecid=';
	enrollment_url = 'https://mobile.comein.cn/mobile/enrollment/detail?id=';
	img_root = 'https://image.comein.cn/comein-files/';
	socket_url = 'wss://im.comein.cn:7443/ws/';
	socket_ip = 'server.comein.cn';

	// 生产地址
	hengsheng_market_src = 'https://wmdnlc5p1.lightyy.com/index.html';
	hengsheng_stock_src = 'https://prhmvxckl.lightyy.com/index.html';
	hengsheng_rzrq_src = 'https://lrr18mo0k.lightyy.com/';

	// 恒生准生产地址
	// hengsheng_market_src = "https://cfdknyjg3.lightyy.com/index.html";
	// hengsheng_stock_src = "https://7vtkwt7o1.lightyy.com/index.html";
	// hengsheng_rzrq_src = "https://ajmpb76hf.lightyy.com/index.html";

	agora_app_id = '173dbf69a0d94c968fbdc163f5badac2';

	pdf_viewer_url = 'https://mobile.comein.cn/pdfviewer/web/viewer.html?file=';

	third_party_url = 'https://tmobile.comein.cn';

	srs_url = 'https://stocke-srs.comein.cn';
	pc_meeting = 'https://www.comein.cn/roadshow/meeting?id=';
	pc_meeting_authorize = 'https://www.comein.cn/roadshow/meeting-hint?redirect_uri=';
	h_five_meeting_detail = 'https://mobile.comein.cn/mobile/meeting/detail?id=';
	ios_route = 'https://ios-route-0.comein.cn';
	mobile_url = 'https://mobile.comein.cn';

	pc_comein_url = 'https://www.comein.cn';

	pc_subject_url = 'https://www.comein.cn/roadshow/subject-detail?id=';

	face_url = 'https://faceid.tencentcloudapi.com';

	wmserverUrl = 'https://test-wmserver.comein.cn';
} else {
	banner_id_adv = '17';
	banner_id_vip = '27';
	banner_id_topic = '1';
	banner_id_recent = '6';
	banner_id_article = '20';
	banner_id_institute = '7';
	banner_id_hot_live = '13';
	banner_id_hot_roadshow = '210';
	banner_id_character = '12';
	banner_id_recommend = '10';
	banner_id_choice = '19';
	banner_id_record_book = '15';
	banner_id_course = '41';
	banner_id_live_preview = '5';
	banner_id_stock_market = '18';
	banner_id_recommend_live = '9';
	banner_id_column = '219';
	banner_id_public_company = '283';
	banner_id_financial = '37';
	banner_styletype_adv = '91';
	banner_styletype_roadshow_preview = '13';
	banner_styletype_recent = '42';
	banner_styletype_hot_roadshow = '43';
	banner_styletype_public_company = '20';
	banner_styletype_column = '121';
	banner_styletype_topic = '111';
	banner_styletype_course = '1701';
	banner_styletype_enrollment = '1303';
	banner_styletype_appoint = '1304';
	banner_styletype_vip_institution = '1305';
	banner_styletype_member = '1306';

	webinapp_url = 'https://testmobile.comein.cn/mobile/';
	pc_roadshow_url = 'https://testnet.comein.cn/roadshow/home/';
	portal_roadshow_url = 'https://testportal.comein.cn/roadshow/home/';
	pc_institute_home = 'https://testnet.comein.cn/institute/';
	vip_pay_return_url = 'https://s.comein.cn/xmt';
	mobile_home = 'https://testmobile.comein.cn/mobile/home';
	topic_url = 'https://testmobile.comein.cn/mobile/topic?id=';
	stock_url = 'https://testmobile.comein.cn/mobile/stock?id=';
	article_url = 'https://testmobile.comein.cn/mobile/article?id=';
	institute_url = 'https://testmobile.comein.cn/mobile/institute?id=';
	character_url = 'https://testmobile.comein.cn/mobile/character?id=';
	real_name_url = 'https://testmobile.comein.cn/mobile/biz/realnameaut';
	event_url = 'https://testmobile.comein.cn/mobile/live/index.html?eid=';
	invsgt_url = 'https://testmobile.comein.cn/mobile/biz/Invsgt/detail?actId=';
	playback_url = 'https://testmobile.comein.cn/mobile/playback/index.html?eid='; // 需要eid，第二个参数为rid(格式为：?eid=4356&rid=2073)
	evaluate_url = 'https://testmobile.comein.cn/mobile/biz/riskevaluation/result';
	k_chart_event =
		'https://testmobile.comein.cn/mobile/stockchart/index.html?timestamp=' + new Date().getTime() + '&stockid=';
	stock_rec_chart_url = 'https://testmobile.comein.cn/mobile/stockrec/stockrecchart.html?stockrecid=';
	enrollment_url = 'https://testmobile.comein.cn/mobile/enrollment/detail?id=';
	img_root = 'https://testimage.comein.cn/comein-files/';
	socket_url = 'wss://im-test.comein.cn:7443/ws/';
	socket_ip = 'testserver.comein.cn';

	// hengsheng_market_src = "https://xete2hrsc.lightyy.com/index.html";
	// hengsheng_market_src = "https://a8eytkc5q.lightyy.com/index.html";
	// hengsheng_stock_src = "https://6uyj71nht.lightyy.com/index.html";
	// hengsheng_rzrq_src = "https://tgv4me96l.lightyy.com";

	// 生产地址
	hengsheng_market_src = 'https://wmdnlc5p1.lightyy.com/index.html';
	hengsheng_stock_src = 'https://prhmvxckl.lightyy.com/index.html';
	hengsheng_rzrq_src = 'https://lrr18mo0k.lightyy.com/';

	agora_app_id = '173dbf69a0d94c968fbdc163f5badac2';

	pdf_viewer_url = 'https://testmobile.comein.cn/pdfviewer/web/viewer.html?file=';

	third_party_url = 'https://htmobile.comein.cn';

	srs_url = 'https://stocke-srs-test.comein.cn';
	pc_meeting = 'https://testportal.comein.cn/roadshow/meeting?id=';
	pc_meeting_authorize = 'https://testportal.comein.cn/roadshow/meeting-hint?redirect_uri=';
	h_five_meeting_detail = 'https://testmobile.comein.cn/mobile/meeting/detail?id=';
	ios_route = 'https://test-ios-route-0.comein.cn';
	mobile_url = 'https://testmobile.comein.cn';

	pc_comein_url = 'https://testportal.comein.cn';

	pc_subject_url = 'https://testportal.comein.cn/roadshow/subject-detail?id=';

	face_url = 'https://faceid.tencentcloudapi.com';

	wmserverUrl = 'https://test-wmserver.comein.cn';
}

export const BANNERID_VIP = banner_id_vip;
export const BANNERID_ADV = banner_id_adv;
export const BANNERID_TOPIC = banner_id_topic;
export const BANNERID_RECENT = banner_id_recent;
export const BANNERID_ARTICLE = banner_id_article;
export const BANNERID_HOT_LIVE = banner_id_hot_live;
export const BANNERID_HOT_ROADSHOW = banner_id_hot_roadshow;
export const BANNERID_INSTITUTE = banner_id_institute;
export const BANNERID_CHARACTER = banner_id_character;
export const BANNERID_RECOMMEND = banner_id_recommend;
export const BANNERID_CHOICE = banner_id_choice;
export const BANNERID_RECORD_BOOK = banner_id_record_book;
export const BANNERID_COURSE = banner_id_course;
export const BANNERID_STOCK_MARKET = banner_id_stock_market;
export const BANNERID_LIVE_PREVIEW = banner_id_live_preview;
export const BANNERID_COLUMN = banner_id_column;
export const BANNERID_PUBLIC_COMPANY = banner_id_public_company;
export const BANNERID_FINANCIAL = banner_id_financial;
export const BANNERID_RECOMMEND_LIVE = banner_id_recommend_live; // 直播
export const BANNERSTYLETYPE_ADV = banner_styletype_adv;
export const BANNERSTYLETYPE_ROADSHOW_PREVIEW = banner_styletype_roadshow_preview;
export const BANNERSTYLETYPE_RECENT = banner_styletype_recent;
export const BANNERSTYLETYPE_PUBLIC_COMPANY = banner_styletype_public_company;
export const BANNERSTYLETYPE_HOT_ROADSHOW = banner_styletype_hot_roadshow;
export const BANNERSTYLETYPE_COLUMN = banner_styletype_column;
export const BANNERSTYLETYPE_TOPIC = banner_styletype_topic;
export const BANNERSTYLETYPE_COURSE = banner_styletype_course;
export const BANNERSTYLETYPE_ENROLLMENT = banner_styletype_enrollment;
export const BANNERSTYLETYPE_APPOINT = banner_styletype_appoint;
export const BANNERSTYLETYPE_VIPINSTITUTION = banner_styletype_vip_institution;
export const BANNERSTYLETYPE_MEMBER = banner_styletype_member;

export const WEBINAPPURL = webinapp_url;
export const PCROADSHOWURL = pc_roadshow_url;
export const PORTALROADSHOWURL = portal_roadshow_url;
export const PCINSTITUTEHOME = pc_institute_home;
export const EVENTURL = event_url;
export const TOPICURL = topic_url;
export const STOCKURL = stock_url;
export const INVSGTURL = invsgt_url;
export const MOBILE = mobile;
export const MOBILEHOME = mobile_home;
export const ARTICLEURL = article_url;
export const PLAYBACKURL = playback_url;
export const EVALUATEURL = evaluate_url;
export const REALNAMEURL = real_name_url;
export const KCHARTEVENT = k_chart_event;
export const CHARACTERURL = character_url;
export const INSTITUTEURL = institute_url;
export const VIPPAYRETURNURL = vip_pay_return_url;
export const STOCKRECCHARTURL = stock_rec_chart_url;
export const ENROLLMENTURL = enrollment_url;
export const IMGROOT = img_root;
export const SOCKETURL = socket_url;
export const SOCKETIP = socket_ip;
export const HSMARKETSRC = hengsheng_market_src;
export const HSSTOCKSRC = hengsheng_stock_src;
export const HENGSHENGSTOCKPAGE = hengsheng_stock_src + '#quote?code={code}&UIGlobal=106&UILoaded=122&UIScrolled=122';
export const HSRZRQPOSTSRC = hengsheng_rzrq_src;
export const AGORAAPPID = agora_app_id;
export const PDFVIEWERURL = pdf_viewer_url;
export const THIRDPARTYURL = third_party_url;
export const SRSURL = srs_url;
export const PCMEETING = pc_meeting;
export const PCMEETINGAUTHORIZE = pc_meeting_authorize;
export const HFIVEMEETINGDETAIL = h_five_meeting_detail;
export const IOSROUTE = ios_route;
export const MOBILEURL = mobile_url;
export const FACEURL = face_url;
export const WMSERVER_URL = wmserverUrl;

export const PCCOMEINURL = pc_comein_url;
export const PCSUBJECTURL = pc_subject_url;
export const ISLOCALHOST = isLocalhost;
export const STATISTIC_NUMBER = {
	ANALYST_LOAD: '20-0-80',
	ANALYST_ROADSHOWTAB: '20-99-1',
	ANALYST_RECOMMENDTAB: '20-99-6',
	ANALYST_SUBUSER: '20-18-0',
	ANALYST_BRIEF: '20-18-1',
	ANALYST_ROADSHOW_CLICK: '20-6-2',
	ANALYST_ARTICLE_CLICK: '20-12-5',
	ANALYST_RECOMMEND_CLICK: '20-14-6',

	COURSE_MORE_CLICK: '25-99-0',
	COURSE_BUY_DETAIL: '25-9-0',

	SECURITYLIST_SECURITY_CLICK: '11-7-0',

	SECURITYLIST_SUBSECURITY_: '11-17-0',

	SECURITY_ALLANALYST_CLICK: '11-99-15',
	SECURITY_LOAD: '11-0-80',
	SECURITY_ROADSHOW_CLICK: '11-1-0',
	SECURITY_ARTICLE_CLICK: '11-5-0',
	SECURITY_INVSGT_CLICK: '11-20-0',
	SECURITY_ANALYST_CLICK: '11-99-3',
	SECURITY_ROADSHOWTAB: '11-99-1',
	SECURITY_VIEWPORTTAB: '11-99-5',
	SECURITY_INVSGTTAB: '11-99-2',

	CHARACTER_LIST_LOAD: '11-20-80',
	CHARACTER_LIST_CLICK: '11-20-3',
	CHARACTER_LIST_SUBUSER: '11-20-18',

	CHIEFR_COMMEND_CLICK: '14-0-6',

	ROADSHOW_RELATED_CLICK: '17-22-1',
	ROADSHOW_RELATEDTAB: '17-99-22',
	ROADSHOW_ATTEND_CLICK: '17-1-0',
	ROADSHOW_LOAD: '17-0-80',
	ROADSHOW_ROOM_LOAD: '17-1-80',

	RECORD_DOWNLOAD_CLICK: '17-2-23',
	RECORD_CHAPTERICON_CLICK: '17-2-21',
	RECORD_DOC_CLICK: '17-2-22',
	RECORD_RELATED_CLICK: '17-22-2',

	RECOMMEND_STOCKREC_RECORD: '14-6-2',
	STOCKRECOMMEND_STOCK_CLICK: '14-4-4',
	STOCKRECOMMEND_ANALYST_CLICK: '14-20-0',
	STOCKRECOMMEND_ANALYST_SUBUSER: '14-20-18',
	CHIEFRECOMMEND_STOCK_SUBUSER: '14-4-6',

	RECOMMEND_LOAD: '14-0-80',

	ARTICLE_LOAD: '12-0-80',
	MARKETWATCHPAGE_ARTICLE_CLICK: '12-5-0',

	TOPICPAGE_TOPIC_CLICK: '10-2-0',

	ROADSHOW_BUY_CLASS: '7-17-9',
	ROADSHOW_BUYCLASS_CONFIRM: '23-24-1',
	ROADSHOW_DETAIL_CLICK: '7-25-0',

	ROADSHOWPREVIEW_EVENT_CLICK: '5-1-0',
	ROADSHOWPREVIEW_RECORD_CLICK: '5-2-0',

	FIRSTPAGE_MARKET_TABS_CLICK: '1-4-1',

	ROADSHOWPREDICT_ENEVT_CLICK: '1-5-1',
	ROADSHOWPREDICT_RECORD_CLICK: '1-5-2',
	ROADSHOWPREDICT_SUBSCRIBE: '1-5-17',

	FIRSTPAGE_RECENT_CLICK: '1-6-2',
	FIRSTPAGE_HOTROADSHOW_CLICK: '1-31-2',
	FIRSTPAGE_COLUMN_CLICK: '1-27-1',

	FIRSTPAGE_COMPANY_CLICK: '1-30-1', //3.6.0 new

	FIRSTPAGE_ECONOMICCLASS_CLICK: '1-28-1', //change previous:1-7-1

	FIRSTPAGE_SPECIAL_TOPIC_CLICK: '1-10-8',
	FIRSTPAGE_SECURITY_CLICK: '1-11-7',
	FIRSTPAGE_MARKET_WATCH_CLICK: '1-12-5',
	FIRSTPAGE_CHIEF_RECOMMEND_CLICK: '1-14-6',

	FIRSTPAGE_ROADSHOWPREDICT_MORE: '1-5-15',
	FIRSTPAGE_RECENT_MORE: '1-6-15',
	FIRSTPAGE_HOTROADSHOW_MORE: '1-31-15',
	FIRSTPAGE_COLUMN_MORE: '1-27-15',
	FIRSTPAGE_FINANCIAL_CLASS_MORE: '1-28-15', //change previous:1-7-15
	FIRSTPAGE_BOOK_SHARE_MORE: '1-8-15',
	FIRSTPAGE_ECONOMIC_VIEW_MORE: '1-9-15',
	FIRSTPAGE_SPECIAL_TOPIC_MORE: '1-10-15',
	FIRSTPAGE_SECURITY_LIST_MORE: '1-11-15',
	FIRSTPAGE_MARKET_WATCH_MORE: '1-12-15',
	FIRSTPAGE_ANALYST_RANK_MORE: '1-13-15',
	FIRSTPAGE_CHIEF_RECOMMEND_MORE: '1-14-15',
	FIRSTPAGE_COMPANY_MORE: '1-30-15', //3.6.0 new

	FIRSTPAGE_SEARCH_CLICK: '1-13-0',

	FIRSTPAGE_AD_CLICK: '1-11-0', //change previous:1-26-0

	RESEARCHPAGE_NOTICEROADSHOW_CLICK: '2-37-0',
	RESEARCHPAGE_RECORDROADSHOW_CLICK: '2-38-0',

	SEARCHPAGE_ROADSHOW_TYPE_CLICK: '1-16-1',
	SEARCHPAGE_ANALYST_TYPE_CLICK: '1-16-3',
	SEARCHPAGE_STOCK_TYPE_CLICK: '1-16-4',
	SEARCHPAGE_ARTICLE_TYPE_CLICK: '1-16-5',
	SEARCHPAGE_SEARCH_CLICK: '1-16-13',
	SEARCHPAGE_CANCEL_CLICK: '1-16-15',

	SEARCHPAGE_ROADSHOW_CLICK: '16-1-1',
	SEARCHPAGE_ANALYST_CLICK: '16-20-3',
	SEARCHPAGE_STOCK_CLICK: '16-4-4',
	SEARCHPAGE_ARTICLE_CLICK: '16-21-5',
	SEARCHPAGE_RECOMMEND_CLICK: '14-13-6',

	SEARCHPAGE_ROADSHOW_SEARCH: '16-13-1',
	SEARCHPAGE_STOCK_SEARCH: '16-13-4',
	SEARCHPAGE_ARTICLE_SEARCH: '16-13-5',
	SEARCHPAGE_SOTCK_SUBSTOCK: '16-4-18',

	// 分析师榜单
	ANALYSTRANK_BACK_CLICK: '13-15-0', // 榜单页面返回按钮点击
	ANALYSTRANK_POPULARITY_CLICK: '13-99-1', // 人气榜tab点击
	ANALYSTRANK_ACHIEVEMENT_CLICK: '13-99-2', // 业绩榜tab点击
	ANALYSTRANK_READER_CLICK: '13-83-0', // 榜单页面说明页点击
	ANALYSTRANK_SHARE_CLICK: '13-16-0', // 榜单页面分享点击
	ANALYSTRANK_ANALYST_CLICK: '13-20-3', // 榜单分析师点击
	ANALYSTRANK_FOLLOW_CLICK: '13-20-18', // 榜单分析师关注按钮点击

	SPECIALTOPICPAGE_SUBTOPIC: '10-17-0',
	SPECIALTOPICPAGE_ROADSHOW_CLICK: '10-0-1',

	// irm线下活动
	ENROLLMENT_DETAIL_LOAD: '43-4-0', // 3.6.1新增

	//3.6.15新增
	PAGE_BROWSE_ROADSHOW: '37-16-0', // typeid: 路演id,content: 路演标题
	PAGE_BROWSE_RECORD: '38-16-0', // typeid: 路演id,content: 路演标题
	PAGE_BROWSE_REPORT: '45-32-0', // typeid: 研报id,content: 研报标题
	PAGE_BROWSE_ENROLLMENT: '43-4-0', // typeid: 调研活动id,content: 调研活动标题
	PAGE_BROWSE_FLAGSHIP: '45-30-0', // typeid: 企业号id,content: 企业号标题 + '企业号'

	PAGE_SHARE_ROADSHOW: '37-17-0', // typeid: 路演id,content: 路演标题
	PAGE_SHARE_RECORD: '38-17-0', // typeid: 路演id,content: 路演标题
	PAGE_SHARE_LIVE: '39-17-0', // typeid: 路演id,content: 路演标题 1.9.4新增
	PAGE_SHARE_REPORT: '45-32-16', // typeid: 研报id,content: 研报标题
	PAGE_SHARE_ENROLLMENT: '43-26-16', // typeid: 调研活动id,content: 调研活动标题
	PAGE_SHARE_FLAGSHIP: '45-30-16', // typeid: 企业号id,content: 企业号标题

	FLAGSHIP_TAB_ROADSHOW_CLICK: '45-35-1', // typeid: 企业号id,content: 企业号标题+'企业号路演列表内容'
	FLAGSHIP_TAB_RESEARCH_CLICK: '45-35-26', // typeid: 企业号id,content: 企业号标题+'企业号调研列表内容'
	FLAGSHIP_TAB_QUESTION_CLICK: '45-35-34', // typeid: 企业号id,content: 企业号标题+'企业号问答列表内容'
	FLAGSHIP_TAB_ANNOUNCEMENT_CLICK: '45-35-33', // typeid: 企业号id,content: 企业号标题+'企业号公告列表内容'
	FLAGSHIP_TAB_REPORT_CLICK: '45-35-32', // typeid: 企业号id,content: 企业号标题+'企业号研报列表内容'
	FLAGSHIP_TAB_CUSTOMIZE_CLICK: '45-35-35', // typeid: 企业号id,content: 企业号标题+'企业号自定义页列表内容'

	POPULARIZE_SPECIAL_PAGE_CLICK: '17-37-0', // 新专场落地页浏览
	POPULARIZE_SPECIAL_CONTACT_CLICK: '17-37-17', // 新专场落地页点击联系方式

	// 3.6.17
	PAGE_BROWSE_RESEARCH: '45-29-36', // typeid: 调研id,content: 调研标题
	PAGE_BROWSE_ANNOUNCEMENT: '45-33-36', // typeid: 公告id,content: 公告标题

	PAGE_SHARE_RESEARCH: '45-29-16', // typeid: 调研id,content: 调研标题
	PAGE_SHARE_ANNOUNCEMENT: '45-33-16', // typeid: 公告id,content: 公告标题

	PAGE_SHARE_INVITE_CARD: '37-38-0', // typeid: 路演id,content: 分享方式（app控制）

	FIRSTPAGE_VIPINSTITUTION_ROADSHOW_CLICK: '1-47-1', // typeid: 路演id
	FIRSTPAGE_VIPINSTITUTION_RECORD_CLICK: '1-47-2', // typeid: 路演id
	FIRSTPAGE_VIPINSTITUTION_MORE: '1-47-15', // 无

	VIPINSTITUTIONLIST_TAG_FOLLOW_CLICK: '47-99-0', // 无
	VIPINSTITUTIONLIST_TAG_CLICK: '47-99-1', // 标签id
	VIPINSTITUTIONLIST_TAG_FILTER: '47-33-0', // 无
	VIPINSTITUTIONLIST_ROADSHOW_CLICK: '47-37-0', //路演id
	VIPINSTITUTIONLIST_RECORD_CLICK: '47-38-0', //路演id

	ROADSHOW_SHARE_USER_OPEN: '1-36-40',

	// 3.8.4
	MEMBER_BUY_CLICK: '48-36-1', // 会员购买

	// 3.9.4
	TOPIC_DETAIL_SHARE: '10-16-0', // 专题研究页分享按钮事件

	// 企业号1.2.0

	PAGE_SHARE_OFFLINE: '45-35-36', //线下活动列表
	PAGE_SHARE_NEWS: '45-35-37', //新闻列表
	// PAGE_SHARE:45-35-38,   //融资融券
	// PAGE_SHARE:45-35-39,   //龙虎榜
	PAGE_SHARE_STOCKHOLDERS: '45-35-40', //股东人数
	PAGE_SHARE_ORGANIZESTOCKHOLDERS: '45-35-41', //机构持股
	PAGE_SHARE_MAJORSTOCKHOLDERS: '45-35-42', //十大股东
	PAGE_SHARE_CIRCULATEMAJORSTOCKHOLDERS: '45-35-43', //十大流通股东

	// 4.0.0
	TOPICPAGE_CLASSIFICATION_OPTION: '10-35-0',
	TOPICPAGE_DETAIL_CLICK: '10-36-0',
	TOPICPAGE_DETAIL_SEARCH: '10-36-13',
	TOPICPAGE_DETAIL_SELECT: '10-36-35',
	TOPICPAGE_DETAIL_ROADSHOW: '10-36-1',

	ROADSHOW_MEETING_APPOINTMENT: '1-47-0',
	ROADSHOW_MEETING_APPOINTMENT_REGISTER: '1-47-93',
	ROADSHOW_MEETING_APPOINTMENT_VIEWDETAIL: '1-47-94',
	ROADSHOW_MEETING_APPOINTMENT_CERTIFICATION: '1-47-95',
	ROADSHOW_MEETING_APPOINTMENT_COLUMN: '1-47-96',
	ROADSHOW_MEETING_APPOINTMENT_COURSE: '1-47-97',
	ROADSHOW_MEETING_APPOINTMENT_NUMBER: '1-47-98',
	ROADSHOW_MEETING_APPOINTMENT_PAYMENT: '1-47-99',

	ROADSHOWPAGE_APPOINTMENT: '36-47-0',
	ROADSHOWPAGE_APPOINTMENT_REGISTER: '36-47-92',
	ROADSHOWPAGE_APPOINTMENT_VIEWDETAIL: '36-47-93',
	ROADSHOWPAGE_APPOINTMENT_CERTIFICATION: '36-47-94',
	ROADSHOWPAGE_APPOINTMENT_COLUMN: '36-47-95',
	ROADSHOWPAGE_APPOINTMENT_COURSE: '36-47-96',
	ROADSHOWPAGE_APPOINTMENT_NUMBER: '36-47-97',
	ROADSHOWPAGE_APPOINTMENT_PAYMENT: '36-47-98',

	ROADSHOWPAGE_INTO_MEETING: '36-92-0',
	ROADSHOWPAGE_REGISTER: '36-93-0',
	ROADSHOWPAGE_REGISTER_REENROLL: '36-93-1',
	ROADSHOWPAGE_VIEWDETAIL: '36-94-0',
	ROADSHOWPAGE_CERTIFICATION: '36-95-0',
	ROADSHOWPAGE_COLUMN: '36-96-1',
	ROADSHOWPAGE_COURSE: '36-97-1',
	ROADSHOWPAGE_NUMBER: '36-98-1',
	ROADSHOWPAGE_PAYMENT: '36-99-1',
	ROADSHOWPAGE_RECORD_PLAY: '36-25-1',

	IDENTITY_REENROLL: '3-54-1',

	HOT_COMPANY_SHARE: '43-30-16',
	HOT_INDUSTRY_SHARE: '43-49-16'
};

export const CONFERENCE_COLORS = {
	THEME_COLOR: '--con-theme-color',
	THEME_COLOR_RGBA: '--con-theme-color-rgba',
	FONT_COLOR: '--con-font-color',
	FONT_COLOR_RGBA: '--con-font-color-rgba',
	TITLE_FONT_COLOR: '--con-title-font-color',
	TITLE_FONT_COLOR_RGBA: '--con-title-font-color-rgba'
};

// 会议权限类型:1-公开，2-专场白名单，3-机构通，4-申请参会
export const CONFERENCE_OPENSTATUS_ENUM = {
	OPEN: 1,
	WHITELIST: 2,
	INSTITUTIONAL: 3,
	APPLY: 4
};

// 会议参会状态： -1 未登录 0 白名单 1 未报名|| 未登记 || 非机构通用户 2 已报名 3 已签到 4 未签署承诺书 5 嘉宾 6 机构用户
export const CONFERENCE_JOINSTATUS_ENUM = {
	NOT_LOGGED_IN: -1,
	WHITELIST: 0,
	NOT_REGISTERED: 1,
	REGISTERED: 2,
	SIGNED_IN: 3,
	UNSIGNED_COMMITMENT_LETTER: 4,
	GUEST: 5,
	INSTITUTIONAL_USERS: 6
};

// 会议报名状态: 0-未提交审核，1-审批中，2-审批通过，3-审批未通过，4-已取消
export const CONFERENCE_VERIFYSTATUS_ENUM = {
	NOT_SUBMITTED: 0,
	APPROVAL: 1,
	PASS: 2,
	NOT_PASS: 3,
	CANCEL: 4
};

// 机构通认证状态: 0 未提交 1 审核通过 2 审核不通过 3 审核中
export const LAST_REVIEW_STATUS = {
	NOT_SUBMITTED: 0,
	PASS: 1,
	NOT_PASS: 2,
	REVIEW: 3
};
